import { useContext } from 'react';
import { NewThemeContext } from '../context/NewThemeContext';

export function useNewTheme() {
  const context = useContext(NewThemeContext);

  return context;
}
